import React,{useRef} from 'react';
import UserIcon from '../../img/UserIcon.png';
import Button from "@mui/material/Button";
import { FormControl, FormLabel, RadioGroup, FormControlLabel, Radio, Box, TextField, Typography } from '@mui/material';
import styles from '../loggedInComponents/loggedInHomeComponents.module.css';
import styles2 from "./AccessCode.module.css";
import { useForm, Controller } from "react-hook-form";

const AccessCodeComponent = () => {

    

    const buttonStyle2 ={
        borderRadius: 0,              
        borderWidth: '4px',           
        borderColor: 'black',         
        color: 'black',
        fontSize:'20px',
        fontWeight:'bold',
        ml: 2,
        '&:hover': {
            borderColor: 'black',
            backgroundColor: 'rgba(0,0,0,0.05)', 
        }
    }

    const formLabelStyle={
        color: 'black', 
        mr: 2, 
        whiteSpace:'nowrap',
        fontWeight:'bold',
        fontSize:"24px",
        '&.Mui-focused': {
            color: 'black',
        },
        '&.MuiFormLabel-root': {
            color: 'black',
        },
        '&.Mui-disabled': {
            color: 'black',
        },
        '&.Mui-error': {
            color: 'black',
        }
    }

    const radioGroupStyle={
        display: 'flex',
        justifyContent: 'space-around',
        width: '100%', 
    }

    const formControlLabelStyle ={
        '& .MuiFormControlLabel-label': {
            fontSize: '24px',
            color:'black'   
        }
    }

    const buttonGradient = 'linear-gradient(to right, #CA7400, #B12F6B, #8B579E)';
    
        const buttonStyle ={
            borderRadius: 999,                 
            border: '1px solid transparent',
            textTransform: 'none',  
            color: '#F8F5FE',
            fontSize:'14px',
            whiteSpace: "nowrap",
            width: "476px",
            height: "52px",
            backgroundClip: 'padding-box, border-box',
            backgroundOrigin: 'border-box',
            backgroundImage: `linear-gradient(#13111B, #13111B), ${buttonGradient}`,
            boxShadow: 'none',
            position: 'relative',
            isolation: 'isolate',
            
            "& .MuiButton-endIcon": {
                position: 'relative',
                zIndex: 2, 
            },
    
            '&::after': {
                content: '""',
                position: 'absolute',
                inset: '1px',          
                background: '#13111B',  
                borderRadius: "999px",
                zIndex: 0,              
            },
    
            '&::before': {
                content: '""', 
                position: 'absolute',
                zIndex: -1,         
                top: '-6px',
                left: '-6px',
                right: '-6px',
                bottom: '-6px',
          
                background: buttonGradient,
                borderRadius: 999,
                
                filter: 'blur(16px)', 
                opacity: 0.6, 
            },
    
            '&:hover': {
                '&::after': {
                    opacity: 0, 
                },
                '&::before': {
                    opacity: 1,
                    filter: 'blur(20px)',
                },
                borderColor: 'none',
                background: buttonGradient,
                boxShadow: 'none', 
            }
        }
    
        const textboxStyle={
            width: "476px",
            height: "52px",
            //This is for styling the base textfield
            "& .MuiOutlinedInput-root": {
                backgroundColor: "#1C1A25",
                color: "#F8F5FE",
                borderRadius:"16px",
    
            //This is for styling the default border
                '& fieldset': {
                    borderColor: '#302C3F',
                    borderWidth: '1px', 
                },
            // //This is for styling fieldset on hover
                '&:hover fieldset': {
                    borderColor: '#302C3F',
                    borderWidth: '1px'
                },
            // This is for styling the fieldset when clicked
             '&.Mui-focused fieldset': {
                borderColor: '#302C3F',
                borderWidth: '1px'
                },
             },
            // This is for styling the input text
            "& .MuiInputBase-input": {
                color: "white", 
            },
            "&.Mui-disabled": {
                "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: '#302C3F', // Keeps the border visible
                }
            },
    
            '& fieldset': {
                borderColor: '#302C3F',
                borderWidth: '1px',
            },
            '&:hover fieldset': {
                borderColor: '#302C3F',
                borderWidth: '1px'
            },
            '&.Mui-focused fieldset': {
                borderColor: '#302C3F',
                borderWidth: '1px'
            },
        
            "& .MuiInputBase-input": {
                color: "white",
                // This is the magic part for disabled text color
                "&.Mui-disabled": {
                    color: "white", 
                    "-webkit-text-fill-color": "white", // Required for some browsers
                }
            },
        }
    
        const canvasRef = useRef(null);
        
    
        const { register, setValue, watch } = useForm({
            defaultValues: {
                uniqueID: ""
            }
        });
    
        const currentID = watch("uniqueID");
        const currentEmail = watch("email");
    
        const startRegistration = async () => {
            const token = localStorage.getItem('token'); 
            try {
                const response = await fetch("/api/initialize-participant", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${token}`
                    },
                    body: JSON.stringify({ email: currentEmail }),
                });
                if (response.status === 401) {
                    alert("Session expired. Please log in again.");
                    localStorage.removeItem("token");
                    window.location.href = "/login";
                    return;
                }
                if (!response.ok) {
                    const errorData = await response.json();
                    throw new Error(errorData.message || "Invalid input or server error");
                }
    
                const data = await response.json();
                
                
                if (data.success) {
                    setValue("uniqueID", data.uniqueId); 
                    console.log("New Participant ID:", data.uniqueId);
                    console.log("Associated Email:", data.associatedEmail);
                    if(currentEmail){
                        alert(`Success! Code ${data.uniqueId} sent to ${currentEmail}`);
                    }
                    setValue("email", "");
                }
            } catch (error) {
                console.error("Initialization failed", error);
                alert("Error: The email entered is invalid or the server failed.");
            }
        };
    
        const handleLogout = () => {
            localStorage.removeItem("token");
            window.location.href = "/login"; 
        };

  return (
    <div className={styles.PSMainBox} sx={{width:"100%"}}>
        <div className={styles2.midBox} sx={{justifyContent:"center"}} >
            <Typography sx={{fontSize: "28px", color:"white"}}>Generate New Code</Typography>
                    
                    {/* <div style={{marginBottom:"25px",marginTop:"100px"}}>
                        <div className={styles2.labelText}>Email</div>
                        <TextField 
                            placeholder='Enter email address here, press "Generate Code"' 
                        
                            {...register("email")}

                            sx={textboxStyle} 
                        />
                    </div> */}
                    <Button 
                        variant="contained" 
                        sx={{...buttonStyle, marginBottom:"25px", marginTop:"100px"}} 
                        onClick={startRegistration}
                    >
                        <Box component="span" sx={{ position: 'relative', zIndex: 1, color:'#F8F5FE' }}>
                            Generate Code              
                        </Box>     
                    </Button>
                    <div style={{marginBottom:"52px", }}>
                        <div className={styles2.labelText}>Access Code</div>
                        <TextField 
                            placeholder="Your access code will appear here" 
                        
                            {...register("uniqueID")}
                            
                            value={currentID}
                            
                            disabled
                            sx={textboxStyle} 
                        />
                    </div>
                    {/* <Button 
                        variant="contained" 
                        sx={{...buttonStyle, marginTop:"60px"}} 
                        onClick={handleLogout}
                    >
                        <Box component="span" sx={{ position: 'relative', zIndex: 1, color:'#F8F5FE' }}>
                            Logout         
                        </Box>     
                    </Button> */}
                </div>
    </div>
  );
};

export default AccessCodeComponent;